import { Component, Input, OnInit } from '@angular/core';
import { RequirementField, DisplayableInfo } from 'ng2-app/modules/borrower/models/application-requirements/application-requirements.interface';
import { UntypedFormGroup, Validators } from '@angular/forms';
import { conformToMask } from 'angular2-text-mask';

@Component({
    selector: 'ba-text',
    templateUrl: 'text-attribute.component.html'
})
export class TextAttributeComponent implements OnInit {

    @Input() field: RequirementField;
    @Input() form: UntypedFormGroup;
    @Input() displayableInfo: DisplayableInfo;
    @Input() disabled: boolean;

    taxIdValue: Function;
    taxIdMask = [/\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/];

    ngOnInit() {
        if (this.isEmailValue) {
            this.control.setValidators(Validators.email);
        }

        if (this.field.value && this.field.alias === 'federalstate_tax_id') {
            this.taxIdValue = conformToMask(this.field.value, this.taxIdMask, {guide: false});
        }
    }

    mask() {
        if (this.field.alias === 'federalstate_tax_id') {
            return {
                mask: this.taxIdMask,
                guide: false
            };
        } else {
            return {
                mask: false,
                guide: false
            };
        }
    }

    get control() {
        return this.form.controls[this.field.alias];
    }

    get isEmailValue() {
        return ['contact.email', 'user.email'].includes(this.field.alias);
    }
}
